<template>
  <v-alert color="white" class="font-weight-bold my-0">
    <v-icon color="primary" class="mr-2 mb-1">fas fa-times-circle</v-icon>
    <span class="table-no-results-text">{{ $t(message) }}</span>
  </v-alert>
</template>

<script>
export default {
  props: {
    message: {
      type: String
    }
  }
};
</script>
